import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { WebimManager } from '../../services/WebimManager';
import * as styles from './WebimIframe.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var WebimIframe = /*#__PURE__*/function (_React$Component) {
  function WebimIframe(props) {
    var _this;
    _classCallCheck(this, WebimIframe);
    _this = _callSuper(this, WebimIframe, [props]);
    _defineProperty(_this, "webim", void 0);
    var accountName = props.accountName,
      _props$host = props.host,
      host = _props$host === void 0 ? 'webim.ru' : _props$host,
      location = props.location;
    _this.webim = new WebimManager(accountName, {}, host, location);
    return _this;
  }
  _inherits(WebimIframe, _React$Component);
  return _createClass(WebimIframe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initWebimManager();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var visible = this.props.visible;
      if (prevProps.visible !== visible) {
        if (visible) {
          this.webim.start();
        } else {
          this.webim.close();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyWebimManager();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("iframe", {
        className: styles['iframe'],
        id: "webim-chat-iframe"
      });
    }
  }, {
    key: "initWebimManager",
    value: function () {
      var _initWebimManager = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props, visible, _this$props$userData, userData, onError, onReady;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, visible = _this$props.visible, _this$props$userData = _this$props.userData, userData = _this$props$userData === void 0 ? null : _this$props$userData, onError = _this$props.onError, onReady = _this$props.onReady;
              if (userData) {
                this.webim.setUser(userData);
              }
              _context.prev = 2;
              _context.next = 5;
              return this.webim.init();
            case 5:
              if (onReady) {
                onReady();
              }
              if (visible) {
                this.webim.start();
              }
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              if (onError) {
                onError(_context.t0);
              }
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 9]]);
      }));
      function initWebimManager() {
        return _initWebimManager.apply(this, arguments);
      }
      return initWebimManager;
    }()
  }, {
    key: "destroyWebimManager",
    value: function destroyWebimManager() {
      this.webim.close();
    }
  }]);
}(React.Component);